module.exports = __webpack_public_path__ + "media/luxury-2026/original-staircase-view-960-463ab4df.jpg";